var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.member && _vm.member.id)?_c('equipment-orders-card',_vm._g(_vm._b({attrs:{"organization-id":_vm.organizationId,"title":_vm.$t('onboarding.commissioning.member.title'),"query":_vm.query,"matches":_vm.isOfMember,"holder":"member","member":_vm.member,"hide-beneficiary":""}},'equipment-orders-card',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }